export const configModalOptions = [
    { value: 1, label: 'enum-configModalBall' },
    { value: 2, label: 'enum-configModalSurface' },
    { value: 3, label: 'enum-configModalSport' },
    { value: 4, label: 'enum-configModalTournamentType' },
];
